import axiosInstance from "./axiosConfig";
import ApiConfig from "./config";
import { ConflictError } from './errors';

export const getSetting = async (businessId) => {
  try {
    const response = await axiosInstance.get(
      ApiConfig.ENDPOINTS.GET_BUSINESS_PROPERTIES,
      { params: { businessId } },
    );

    const data = response.data;
    const version = data?.version || 0;

    let terminalData = [];
    if (data && data.data && Array.isArray(data.data)) {
      terminalData = data.data;
    } else if (Array.isArray(data)) {
      terminalData = data;
    } else if (data && typeof data === "object") {
      terminalData = [data];
    }

    return { data: terminalData, version };
  } catch (error) {
    throw error;
  }
};

export const addOrUpdateSetting = async (
  businessId,
  terminalData,
  version = 0,
) => {
  try {
    if (!businessId) throw new Error("Business ID is required");

    const buildPayload = (terminal) => ({
      weekendSrchEnabled: terminal.weekendSrchEnabled ?? false,
      weekendSrchP: Number(terminal.weekendSrchP) || 0,
      refundEnabled: terminal.refundEnabled ?? true,
      // ✅ FIX: Accept BOTH `weekendSrchDays` and `weekendDays` keys
      weekendSrchDays: terminal.weekendSrchDays ?? terminal.weekendDays ?? [],
      phSurcharges: (terminal.phSurcharges || []).map((ph) => ({
        id: ph.id ?? 0,
        desc: ph.desc ?? "",
        from: ph.from ?? null,
        to: ph.to ?? null,
        srchPercentage: Number(ph.srchPercentage) || 0,
      })),
      version,
    });

    const payload = Array.isArray(terminalData)
      ? terminalData.map(buildPayload)
      : buildPayload(terminalData);

    const response = await axiosInstance.put(
      `${ApiConfig.ENDPOINTS.UPDATE_BUSINESS_PROPERTIES}?businessId=${encodeURIComponent(
        businessId,
      )}`,
      payload,
    );

    return response.data;
  } catch (error) {
    if (error.response?.status === 409) {
      const data = error.response.data || {};
      throw new ConflictError(
        data.detail || data.message || "Conflict detected",
        data,
      );
    }
    throw error;
  }
};